// extracted by mini-css-extract-plugin
export default {"list-icon":"list-icon--GfWz5iAqir","listIcon":"list-icon--GfWz5iAqir","dark":"dark--rge+P0ccgZ"};